<template>
  <div>
    <overlay-loading v-model="loadingOverlay" />

    <modal-cadu v-model="valueData" :width="754" close>
      <div slot="all" class="pt-8 pb-4">
        <component-loading :value="loading" class="pb-6" />

        <div slot="header" class="px-10">
          <v-row>
            <v-col cols="auto"> <div class="primary1--text headline font-weight-bold">ANEXO</div> </v-col>

            <transition name="fade">
              <v-row alig="end" justify="end" class="pr-4" v-if="selected.length > 0">
                <v-col cols="auto">
                  <button-rounded iconName="download" :iconSize="16" @click="downloadVariosDocumentos" />
                </v-col>
              </v-row>
            </transition>
          </v-row>
        </div>

        <div slot="body" v-if="!loading" class="border-body pb-6 px-10">
          <v-row v-if="anexos.length > 0">
            <v-col cols="auto">
              <div class="subtitle-1 fontColor--text font-weight-bold">
                Arquivos disponíveis para download:
              </div>
            </v-col>
          </v-row>

          <v-row v-if="anexos.length > 0">
            <v-col v-for="(anexo, index) in anexos" :key="index" cols="12" sm="3" md="3" xs="2">
              <h4 v-if="anexo.abaRelacionada.nome" class="subtitle-1 fontColor--text">
                Aba {{ anexo.abaRelacionada.nome }}
              </h4>
              <div class="file-container">
                <checkbox-cadu class="check" v-model="selected" :value="index" />

                <div
                  @click="hoverIndex === index ? downloadDocumento(index) : ''"
                  :class="iconName === 'download' && hoverIndex === index ? 'file-anexo' : 'grey5 file-anexo'"
                  @mouseover="hoverBox(index)"
                  @mouseleave="leaveBox"
                >
                  <icon class="primary1--text" :name="hoverIndex === index ? 'download' : 'file'" :size="40" />
                </div>
              </div>

              <div class="center mt-2">{{ anexo.arquivo.nome }}</div>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col>
              <div class="primary1--text title">Não há anexos para fazer download</div>
            </v-col>
          </v-row>
        </div>

        <div slot="footer" class="check-line">
          <v-row align="end" justify="end" class="pt-4 px-10">
            <v-col cols="auto">
              <button-cadu text="VOLTAR" @click="$emit('input', false)" />
            </v-col>
          </v-row>
        </div>
      </div>
    </modal-cadu>
  </div>
</template>

<script>
import Pendencia from '@/services/Pendencia/Pendencia'
import Anexo from '@/services/Anexos/Anexo'

export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      valueData: this.value,
      loading: false,
      anexos: [],
      selected: [],
      iconName: 'file',
      hoverIndex: -1,
      tokenBearer: localStorage.getItem('tokenBearer'),
      loadingOverlay: false
    }
  },

  methods: {
    async downloadVariosDocumentos() {
      this.loadingOverlay = true

      for (const index of this.selected) {
        await this.downloadDocumento(index)
      }

      this.loadingOverlay = false
    },
    async downloadDocumento(index) {
      this.loadingOverlay = true

      const uuid = this.anexos[index].arquivo.uuid
      const container = this.anexos[index].arquivo.container
      const image = `${this.$appConfig.config.API}/api/arquivos/${container}/${uuid}`
     
      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
    
      await anexo
        .exportarAnexo(image)
        .then((res) => {
          let content = res.headers['content-disposition']
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
          document.body.appendChild(link)
          link.click()

        })
        .catch((err) => {
          this.showError = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.message
        })
        .finally(() => {
          this.loadingOverlay = false
        })
    },
    async start(id) {
      this.selected = []
      this.loading = true

      const pendencia = new Pendencia(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      return await pendencia
        .getDocumentoByHistorico(id)
        .then(({ data }) => (this.anexos = data))
        .catch((err) => {
          this.showError = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.message
        })
        .finally(() => (this.loading = false))
    },

    hoverBox(index) {
      if (this.selected.length < 1) {
        this.iconName = 'download'
        this.hoverIndex = index
      }
    },
    leaveBox() {
      this.iconName = 'file'
      this.hoverIndex = -1
    }
  },

  watch: {
    value() {
      this.valueData = this.value
      this.showtemp = this.value
    },
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    },
    selected() {
      if (this.hoverIndex > -1) {
        this.hoverIndex = -1
      }
    }
  }
}
</script>

<style lang="sass">
.file-container
  position: relative
  .check
    z-index: 99999
    position: absolute
    left: 8px
    top: 4px

.file-anexo
    height: 100px
    border-radius: 10px
    text-align: center
    padding: 31px 0
    position: relative
    border: 1px solid #dee2e6
    transition: background .2s ease
    &:hover
      cursor: pointer
.center
    text-align: center

.check-line
    border-top: 1px solid #9E9E9E80

.fade-enter-active .fade-leave-active
  transition: opacity .3s ease

.fade-enter .fade-leave-to
  opacity: 0
</style>
